import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'hh-family-call-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './family-call-widget.component.html',
  styleUrls: ['./family-call-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FamilyCallWidgetComponent {
}
